import serviceGaragentore from '@assets/leistungen/garagentore/garagentore.jpg';
import serviceIndustrietore from '@assets/leistungen/industrietore/industrietore.jpeg';
import serviceBrandschutz from '@assets/leistungen/brandschutz/tueren.jpeg';
import serviceUvv from '@assets/leistungen/uvv/uvv.jpg';
import serviceUvv1 from '@assets/leistungen/uvv/uvv-1.jpeg';
import serviceMetallbau from '@assets/leistungen/metallbau/metallbau.jpg';
import metallbauGelaenderBus from '@assets/leistungen/metallbau/gelaender-mit-bus.webp';
import metallbau1 from '@assets/leistungen/metallbau/metallbau-1.jpeg';
import metallbau5 from '@assets/leistungen/metallbau/metallbau-5.jpeg';
import metallbau8 from '@assets/leistungen/metallbau/metallbau-8.jpeg';
import rosenbogenHund from '@assets/leistungen/metallbau/rosenbogen-hund.jpeg';
import serviceEinbruchschutz from '@assets/leistungen/einbruchschutz/fenstergitter.jpeg';
import fenstergitter1 from '@assets/leistungen/einbruchschutz/fenstergitter-1.jpeg';
import fenstergitter2 from '@assets/leistungen/einbruchschutz/fenstergitter-2.jpeg';
import fenstergitter3 from '@assets/leistungen/einbruchschutz/fenstergitter-3.jpeg';
import serviceVerladebruecken from '@assets/leistungen/verladebruecken/verladebruecken.jpeg';

export type ServiceData = {
  route: string;
  title: string;
  subtitle: string;
  heroImg?: string;
  useIcon?: "truck" | "shieldalert";
  description: string[];
  details: string[];
  advantages?: string[];
  whyBritz?: string[];
  gallery?: { src: string; alt: string; caption?: string }[];
};

export const serviceData: ServiceData[] = [
  {
    route: "/garagentore",
    title: "Garagentore",
    subtitle: "Fachgerechte Montage, Wartung und Reparatur von Garagentoren – zuverlässig und sicher aus einer Hand. Wir betreuen bestehende Toranlagen und liefern auf Wunsch neue Garagentore von Hörmann.",
    heroImg: serviceGaragentore,
    description: [
      "Garagentore werden täglich genutzt und sollten zuverlässig funktionieren. Wir übernehmen die Wartung, Reparatur und Instandhaltung Ihrer Garagentoranlage und sorgen für Sicherheit sowie eine einwandfreie Funktion.",
      "Darüber hinaus liefern und montieren wir neue Garagentore der Firma Hörmann – passend zu Ihren Anforderungen und Ihrem Gebäude. Für Garagen ohne Stromversorgung bieten wir Ihnen z.B. Lösungen mit Akku-Torantrieb, auf Wunsch auch in Verbindung mit Solar.",
      "Sie haben Interesse an einem neuen Garagentor? Kontaktieren Sie uns gerne! Wir kommen zur Beratung zu Ihnen und erstellen Ihnen ein kostenloses und unverbindliches Angebot.",
      "Auch für Reparaturen an Toren sämtlicher Hersteller sind wir Ihr zuverlässiger Ansprechpartner in der Region!",
    ],
    details: [
          "UVV-Prüfungen nach ASR A1.7",
          "Wartung und Instandhaltung von Toranlagen",
          "Reparaturen und Austausch defekter Bauteile",
          "Verkauf und Montage neuer Tore (inkl. Demontage und Entsorgung des alten Tores)",
          "Austausch von Antrieben und Zubehör",
          
    ],
    advantages: [
      "Fachgerechte Wartung und Reparatur",
      "Zuverlässiger Service rund um Toranlagen",
      "Verkauf und Montage neuer Tore",
      "Für Privatkunden und Gewerbebetriebe",
    ],
    gallery: [
      {
        src: "/gallery/garagentore/tor1.jpg",
        alt: "Modernisiertes Garagentor mit Solaranlage bei einem Kundenprojekt von Tür- und Torservice Britz",
        caption: "Garagentor-Service",
      },
      {
        src: "/gallery/garagentore/tor2.jpg",
        alt: "Weiße Sektionaltore in einer Tiefgarage nach Montage und Einstellung",
        caption: "Sektionaltore",
      },
      {
        src: "/gallery/garagentore/tor3.jpg",
        alt: "Garagentor in Holzoptik nach sauberer Montage durch Tür- und Torservice Britz",
        caption: "Garagentor-Montage",
      },
      {
        src: "/gallery/garagentore/tor4.jpg",
        alt: "Anthrazitfarbenes Garagentor mit Schlupftür nach Service und Einstellung",
        caption: "Garagentor mit Schlupftür",
      },
      {
        src: "/gallery/garagentore/tor-willi.jpeg",
        alt: "Montiertes Garagentor mit Holzverkleidung bei einem Kundenprojekt in der Region Öhringen",
        caption: "Garagentor-Projekt",
      },
      {
        src: "/gallery/garagentore/sektionaltor-anthrazit-verglasung.webp",
        alt: "Anthrazitfarbenes Sektionaltor mit zwei Verglasungsreihen in einer Holzkonstruktion",
        caption: "Sektionaltor mit Verglasung",
      },
      {
        src: "/gallery/garagentore/sektionaltor-rusty-steel.webp",
        alt: "Garagen-Sektionaltor in markanter Rusty-Steel-Optik",
        caption: "Sektionaltor in Rusty-Steel-Optik",
      },
      {
        src: "/gallery/garagentore/sektionaltor-weiss.webp",
        alt: "Breites weißes Garagen-Sektionaltor mit moderner Oberfläche",
        caption: "Weißes Sektionaltor",
      },
      {
        src: "/gallery/garagentore/sektionaltor-holzoptik.webp",
        alt: "Breites Garagen-Sektionaltor in warmer Holzoptik",
        caption: "Sektionaltor in Holzoptik",
      },
      {
        src: "/gallery/garagentore/sektionaltor-schlupftuer-verglasung.webp",
        alt: "Graues Sektionaltor mit Schlupftür und großzügiger Verglasung",
        caption: "Sektionaltor mit Schlupftür",
      },
    ],
  },
  {
    route: "/industrietore",
    title: "Industrietore",
    subtitle: "Zuverlässiger Service für Industrie und Gewerbe: Wir kümmern uns um Wartung, Reparatur und Montage von Industrietoren – schnell, fachgerecht und passend zu Ihrem Betrieb.",
    heroImg: serviceIndustrietore,
    description: [
      "Industrietore sind täglich hohen Belastungen ausgesetzt und müssen zuverlässig funktionieren, um Betriebsabläufe nicht zu beeinträchtigen. Ein Defekt oder Ausfall kann Zeit kosten und den gesamten Ablauf im Unternehmen stören. Deshalb stehen wir Ihnen mit schneller Unterstützung, fachgerechter Wartung und zuverlässigen Reparaturen zur Seite.",
      "Tür- und Torservice Britz übernimmt nicht nur die Montage und den Verkauf von Industrietoren, sondern auch die regelmäßige Prüfung, Wartung und Reparatur bestehender Toranlagen. Gerade im gewerblichen Bereich ist eine zuverlässige Funktion entscheidend – wir sorgen dafür, dass Ihre Tore sicher, einsatzbereit und langlebig bleiben.",
      "Wir betreuen verschiedenste Industrietore sämtlicher Fabrikate – darunter z.B. Hofschiebetore, Falttore, Sektional- und Rolltore. Auch sicherheitsrelevante Komponenten wie Lichtschranken, Sicherheitsleisten, Torsteuerungen oder Absturzsicherungen prüfen und warten wir fachgerecht. Defekte erkennen wir frühzeitig und beheben Probleme schnell und zuverlässig.",
      "Dank langjähriger Erfahrung kennen wir die Anforderungen unterschiedlichster Branchen – von Logistik und Produktion bis hin zu Gewerbe und Landwirtschaft. Ob Neuinstallation, Prüfung oder Reparatur: Wir finden Lösungen, die zu Ihrem Betrieb passen.",
      "Unser geschultes Fachpersonal verfügt selbstverständlich über die erforderlichen Schulungen und Zertifikate zur Prüfung und Wartung von Toranlagen sowie über langjährige Erfahrung in diesem Bereich.",
      "Wir betreuen nicht nur Ihre kraftbetätigten Toranlagen, sondern sind auch zertifiziert zur Prüfung von Brandschutzabschlüssen samt Feststellanlagen und Verladebrücken. Somit bieten wir Ihnen einen einzigen Ansprechpartner für sämtliche Leistungen im Bereich Türen, Tore und Verladetechnik. Erfahren Sie mehr unter der jeweiligen Rubrik.",
      "Sie haben Interesse an unserem Service? Kontaktieren Sie uns gerne!",
    ],
    details: [
       "Montage und fachgerechte Inbetriebnahme von Industrietoren",
       "UVV-Prüfung nach ASR A1.7 und Wartung von kraftbetätigten Toranlagen",
       "Reparatur und Austausch von Torantrieben, Steuerungen und Verschleißteilen",
       "Prüfung und Einstellung von Sicherheitseinrichtungen",
       "Fehlerdiagnose und schnelle Störungsbeseitigung",
       "Ersatzteilservice für Ihre Toranlagen",
    ],
    advantages: [
      "Schnelle Hilfe bei Ausfällen und Störungen",
      "Fachgerechte Wartung für langlebige Toranlagen",
      "Erfahrung mit verschiedensten Industrie- und Gewerbetoren",
      "Zuverlässiger Service für Gewerbe, Industrie und Landwirtschaft",
      "Persönliche Beratung und individuelle Lösungen",
      "Termintreue, saubere Arbeit und direkte Ansprechpartner",
    ],
  },
  {
    route: "/brandschutztueren-tore",
    title: "Brandschutztüren und -tore",
    subtitle: " Wartung, Prüfung, Reparatur und Montage von Brandschutztüren und -toren – fachgerecht, zuverlässig und gemäß geltenden Sicherheitsanforderungen.",
    heroImg: serviceBrandschutz,
    description: [
      "Brandschutztüren und -tore müssen jederzeit zuverlässig funktionieren und selbstständig schließen. Wir übernehmen die regelmäßige Wartung, Prüfung und Reparatur Ihrer Brandschutzelemente und sorgen dafür, dass Sicherheitsanforderungen eingehalten werden, um im möglichen Brandfall Schäden möglichst gering zu halten.",
      "Darüber hinaus liefern und montieren wir neue Brandschutztüren und -tore passend zu Ihrem Objekt und Ihren Anforderungen.",
      "Ob Gewerbebetrieb, Industrie, Mehrfamilienhaus oder öffentliche Einrichtung - wir sorgen dafür, dass Ihre Brandschutzelemente dauerhaft funktionstüchtig bleiben.",
      "Unser geschultes Fachpersonal verfügt selbstverständlich über die erforderlichen Schulungen und Zertifikate zur Prüfung und Wartung von Brandschutztüren und -toren sowie über langjährige Erfahrung in diesem Bereich.",
      "Wir betreuen nicht nur Ihre Brandschutztüren und -tore, sondern sind auch zertifiziert zur Prüfung von kraftbetätigten Tür- und Toranlagen und Verladebrücken. Somit bieten wir Ihnen einen einzigen Ansprechpartner für sämtliche Leistungen im Bereich Türen, Tore und Verladetechnik. Erfahren Sie mehr unter der jeweiligen Rubrik!",
      "Sie haben Interesse an unserem Service? Kontaktieren Sie uns gerne!",
    ],
    details: [
      "UVV-Prüfungen für kraftbetätigte Tore nach ASR A1.7",
      "Prüfung von Brandschutztüren und -toren",
      "UVV-Prüfungen für Verladerampen",
      "Prüfungen von Leitern und Tritten",
      "Kontrolle sicherheitsrelevanter Bauteile",
      "Dokumentation der Prüfergebnisse",
      "Erinnerung an anstehende Prüftermine",
      "Reparaturen an Türen, Toren und Verladetechnik",
    ],
    whyBritz: [
      "Fachgerechte Wartung und Reparatur",
      "Zuverlässiger Service rund um Brandschutzelemente",
      "Verkauf und Montage neuer Brandschutztüren",
      "Schnelle und saubere Ausführung",
      "Für Gewerbe, Industrie und öffentliche Einrichtungen",
    ],
  },
  {
    route: "/uvv-pruefung",
    title: "UVV-Prüfungen",
    subtitle: "Fachgerechte UVV-Prüfungen für Tore, Brandschutztüren und Verladerampen – zuverlässig, dokumentiert und fristgerecht.",
    heroImg: serviceUvv,
    description: [
      "Regelmäßige UVV-Prüfungen nach ASR A1.7 erhöhen die Sicherheit und helfen dabei, Ausfälle sowie Schäden frühzeitig zu vermeiden. Wir prüfen kraftbetätigte Tore, Brandschutztüren und Verladerampen fachgerecht nach den geltenden Vorgaben.",
      "Bei der Prüfung kontrollieren wir sicherheitsrelevante Komponenten und dokumentieren die Ergebnisse nachvollziehbar.",
      "Auf Wunsch erinnern wir Sie an anstehende Prüftermine, damit vorgeschriebene Prüfintervalle zuverlässig eingehalten werden.",
    ],
    details: [
      "UVV-Prüfungen für kraftbetätigte Tore",
      "Prüfung von Brandschutztüren und -toren",
      "UVV-Prüfungen für Verladerampen und Verladebrücken",
      "Kontrolle sicherheitsrelevanter Bauteile",
      "Dokumentation der Prüfergebnisse",
      "Erinnerung an anstehende Prüftermine",
    ],
    whyBritz: [
      "Fachgerechte Durchführung der UVV-Prüfungen",
      "Dokumentierte und nachvollziehbare Ergebnisse",
      "Prüfung von Toren, Brandschutz und Verladerampen",
      "Zuverlässige Terminplanung",
      "Für Gewerbe und Industrie",
    ],
    gallery: [
      {
        src: serviceUvv1,
        alt: "Prüfung einer Toranlage im Rahmen der fachgerechten UVV-Prüfung",
        caption: "UVV-Prüfung",
      },
      {
        src: serviceUvv,
        alt: "Gewartetes Tor nach Kontrolle und UVV-Prüfung durch Tür- und Torservice Britz",
        caption: "Toranlagen-Wartung",
      },
    ],
  },
  {
    route: "/metallbauarbeiten",
    title: "Metallbauarbeiten",
    subtitle: "Individuelle Metallbauarbeiten für Innen- und Außenbereiche",
    heroImg: metallbauGelaenderBus,
    description: [
      "Als Metallbaubetrieb fertigen wir individuelle Lösungen aus Stahl und Edelstahl V2A - abgestimmt auf Ihre Anforderungen.",
      "Unser Leistungsspektrum reicht von Maßanfertigungen wie Handläufen und Fenstergittern bis hin zu Reparaturen, Stahlkonstruktionen und individuellen Sonderanfertigungen. Ob Privatkunde oder Gewerbebetrieb - wir unterstützen Sie bei Ihren Projekten zuverlässig und fachgerecht.",
      "Sie sind auf der Suche nach einer individuellen Lösung für Ihr Vorhaben? Kontaktieren Sie uns gerne!",
    ],
    details: [
      "Geländer und Handläufe",
      "Zäune und Gartentore",
      "Fenstergitter und Einbruchschutzlösungen",
      "Sichtschutzelemente",
      "Anfahrschutz für z.B. HRL",
      "Lichtschachtabdeckungen",
      "Rosenbögen, Rankhilfen und Individuelles für den Garten",
      "Reparaturen und Anpassungen bestehender Metallbauteile",
      "Individuelle Sonderanfertigungen aus Stahl oder Edelstahl V2A",
    ],
    gallery: [
      {
        src: metallbauGelaenderBus,
        alt: "Edelstahl-Handlauf vor einem Kundenobjekt mit Fahrzeug der Schlosserei Britz",
        caption: "Handlauf und Geländerbau",
      },
      {
        src: serviceMetallbau,
        alt: "Individuelle Metallbauarbeit aus Stahl vom Meisterbetrieb Tür- und Torservice Britz",
        caption: "Metallbauarbeit",
      },
      {
        src: metallbau1,
        alt: "Gefertigte Metallkonstruktion für ein Kundenprojekt in der Region Öhringen",
        caption: "Sonderanfertigung",
      },
      {
        src: metallbau5,
        alt: "Metallbauarbeit mit sauberer Verarbeitung und fachgerechter Montage",
        caption: "Metallbau-Detail",
      },
      {
        src: metallbau8,
        alt: "Metallbauarbeit für den Außenbereich nach Maß gefertigt und montiert",
        caption: "Außenbereich",
      },
      {
        src: rosenbogenHund,
        alt: "Individuell gefertigter Rosenbogen aus Metall in einem Garten",
        caption: "Garten-Metallbau",
      },
    ],
  },
  {
    route: "/einbruchschutz",
    title: "Einbruchschutz",
    subtitle: "Individuelle Lösungen für mehr Sicherheit – Fenstergitter, Zusatzsicherungen und Einbruchschutz für Türen und Fenster.",
    heroImg: serviceEinbruchschutz,
    description: [
      "Wir fertigen individuelle Fenstergitter und bieten passende Lösungen für den Einbruchschutz an Türen und Fenstern. Ziel ist es, Schwachstellen zu reduzieren und den Schutz Ihres Gebäudes zu erhöhen.",
      "Darüber hinaus montieren wir passende ABUS Zusatzprodukte, wie z.B. Bandsicherungen oder Zusatzschlösser - abgestimmt auf Ihre Fenster, Türen und Ihre individuellen Anforderungen.",
      "Bereits seit 2005 sind wir aufgenommener Handwerksbetrieb im aktuellen Errichternachweis „Mechanische Sicherungseinrichtungen“ des Landeskriminalamtes Baden-Württemberg.",
      "Gerne bieten wir Ihnen somit eine Begehung Ihres Hauses auch in Zusammenarbeit mit der Kriminalpolizei an, um mögliche Schwachstellen festzustellen und entsprechend abzusichern.",
      "Ob Privatkunde oder Gewerbebetrieb – wir beraten Sie zu passenden Möglichkeiten und finden eine individuelle Lösung für Ihr Objekt. Sprechen Sie uns gerne an!",
    ],
    details: [
      "Individuelle Fenstergitter nach Maß",
      "Montage passender ABUS Zusatzprodukte",
      "Einbruchschutz für Türen und Fenster",
      "Individuelle Lösungen passend zum Gebäude",
      "Beratung zu geeigneten Sicherheitsmaßnahmen",
      "Erneuerung von Schließanlagen",
    ],
    whyBritz: [
      "Individuelle Fenstergitter nach Maß",
      "Montage passender ABUS Zusatzprodukte",
      "Geprüfte Fachkompetenz im Einbruchschutz",
      "Für Privatkunden und Gewerbebetriebe",
    ],
    gallery: [
      {
        src: serviceEinbruchschutz,
        alt: "Montierter Einbruchschutz an einem Fenster durch Tür- und Torservice Britz",
        caption: "Einbruchschutz",
      },
      {
        src: fenstergitter1,
        alt: "Individuell gefertigtes Fenstergitter als Sicherheitslösung für ein Kundenprojekt",
        caption: "Fenstersicherung",
      },
      {
        src: fenstergitter2,
        alt: "Fenstergitter nach Maß für mehr Sicherheit am Gebäude",
        caption: "Fenstergitter nach Maß",
      },
      {
        src: fenstergitter3,
        alt: "Nachgerüsteter mechanischer Einbruchschutz an einem Fenster",
        caption: "Mechanischer Schutz",
      },
    ],
  },
  {
    route: "/verladebruecken",
    title: "Verladebrücken",
    subtitle: "Wartung, UVV-Prüfung, Reparatur und Montage von LKW-Verladerampen/LKW-Verladebrücken – für einen sicheren und reibungslosen Warenumschlag.",
    heroImg: serviceVerladebruecken,
    description: [
      "Für einen sicheren und reibungslosen Warenumschlag müssen Verladebrücken zuverlässig funktionieren. Wir übernehmen die regelmäßige Wartung, gesetzlich vorgeschriebene UVV-Prüfungen sowie Reparaturen Ihrer Verladebrücken.",
      "Darüber hinaus liefern und montieren wir bei Bedarf neue Verladesysteme passend zu Ihren Anforderungen und den Gegebenheiten vor Ort.",
      "Regelmäßige Wartung und Prüfungen helfen dabei, Ausfälle zu vermeiden und die Betriebssicherheit langfristig sicherzustellen.",
      "Wir betreuen nicht nur Ihre Verladebrücken, sondern sind auch zertifiziert zur Prüfung von kraftbetätigten Tür- und Toranlagen und Brandschutztüren und -toren. Somit bieten wir Ihnen einen einzigen Ansprechpartner für sämtliche Leistungen im Bereich Türen, Tore und Verladetechnik. Erfahren Sie mehr unter der jeweiligen Rubrik!",
      "Sie haben Interesse an unserem Service? Kontaktieren Sie uns gerne!",
    ],
    details: [
      "Wartung und Instandhaltung von Verladebrücken",
      "UVV-Prüfungen von Verladesystemen",
      "Reparaturen und Austausch defekter Bauteile",
      "UVV-Prüfung erfolgt gemäß der DGUV-Regel 108-006",
      "Prüfung sicherheitsrelevanter Komponenten",
      "Verkauf und Montage neuer Verladebrücken",
      "Dokumentation der durchgeführten Arbeiten",
    ],
    whyBritz: [
      "Fachgerechte Wartung und Reparatur",
      "Zuverlässiger Service rund um Verladebrücken",
      "UVV-Prüfungen und Dokumentation",
      "Verkauf und Montage neuer Verladesysteme",
      "Für Gewerbe und Industrie",
    ],
  },
];
